document.querySelectorAll('.product-gallery-static').forEach(function(gallery) {
  var modal = document.getElementById('ProductModal-' + gallery.dataset.sectionId);
  if (!modal) return;

  var cursor = gallery.closest('.product__media-wrapper')
    ? gallery.closest('.product__media-wrapper').querySelector('.gallery-cursor--static')
    : null;

  gallery.querySelectorAll('.product-gallery-static__item[data-media-id]').forEach(function(item) {
    item.addEventListener('click', function(event) {
      if (event.target.closest('video, iframe, button, a')) return;
      modal.show(item);
    });

    item.querySelectorAll('video').forEach(function(video) {
      video.muted = true;
      video.setAttribute('muted', '');
      video.setAttribute('playsinline', '');
      video.setAttribute('autoplay', '');
      var play = function() {
        var promise = video.play();
        if (promise && typeof promise.catch === 'function') promise.catch(function() {});
      };
      if (video.readyState >= 2) play();
      else video.addEventListener('loadedmetadata', play, { once: true });
    });

    if (cursor && item.classList.contains('product-gallery-static__item--image')) {
      item.addEventListener('mouseenter', function() { cursor.classList.add('show'); });
      item.addEventListener('mouseleave', function() { cursor.classList.remove('show'); });
      item.addEventListener('mousemove', function(e) {
        cursor.style.left = (e.clientX - 25) + 'px';
        cursor.style.top = (e.clientY - 25) + 'px';
      });
    }
  });

  var btn = gallery.querySelector('.product-gallery-static__load-more');
  if (btn) {
    var firstItem = gallery.querySelector('.product-gallery-static__item[data-media-id]');
    btn.addEventListener('click', function() { if (firstItem) modal.show(firstItem); });
  }
});

document.querySelectorAll('.product--display-gallery, .product--display-grid, .product--display-collage').forEach(function(product) {
  var mq = window.matchMedia('(min-width: 750px)');
  var mediaColumn = product.querySelector('.product__media-wrapper');
  var infoColumn = product.querySelector('.product__info-column');
  var productSection = product.closest('.product-section') || product;
  var scrollScope = product.closest('.shopify-section') || productSection;

  if (!mediaColumn || !infoColumn) return;

  function canScroll(element, deltaY) {
    if (!element || !deltaY) return false;
    if (deltaY > 0) return element.scrollTop + element.clientHeight < element.scrollHeight - 1;
    return element.scrollTop > 0;
  }

  scrollScope.addEventListener('wheel', function(event) {
    if (event.target.closest('product-modal[open]')) return;
    
    if (!mq.matches || event.defaultPrevented) return;
    if (Math.abs(event.deltaY) <= Math.abs(event.deltaX)) return;
    if (event.target !== scrollScope && !productSection.contains(event.target)) return;

    var sectionRect = productSection.getBoundingClientRect();
    if (event.clientY < sectionRect.top || event.clientY > sectionRect.bottom) return;

    var eventMediaColumn = event.target.closest('.product__media-wrapper');
    if (event.target.closest('.product__info-column')) return;

    if (eventMediaColumn) {
      if (canScroll(mediaColumn, event.deltaY)) return;
      if (!canScroll(infoColumn, event.deltaY)) return;

      event.preventDefault();
      infoColumn.scrollTop += event.deltaY;
      return;
    }

    var productRect = product.getBoundingClientRect();
    var targetColumn = event.clientX < productRect.left + productRect.width / 2
      ? mediaColumn
      : infoColumn;

    if (targetColumn === mediaColumn && !canScroll(mediaColumn, event.deltaY)) {
      if (!canScroll(infoColumn, event.deltaY)) return;
      targetColumn = infoColumn;
    }

    if (!canScroll(targetColumn, event.deltaY)) return;

    event.preventDefault();
    targetColumn.scrollTop += event.deltaY;
  }, { passive: false });
});
